import { render, staticRenderFns } from "./CustomRruleDialog.vue?vue&type=template&id=5b0bc8f6&"
import script from "./CustomRruleDialog.vue?vue&type=script&lang=js&"
export * from "./CustomRruleDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomRruleDialog.vue?vue&type=style&index=0&id=5b0bc8f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports